<template>
    <!-- OVERVIEW -->
    <section class="overview" id="overview">
        <div class="container">
            <!-- Section Header -->
            <div class="section-header">
                <h2 class="section-title">Возможности</h2>
                <h3 class="section-subtitle">
                    Плюс ко всему у нас есть весь стандартный набор функций</h3>
            </div>
            <!-- End Section Header -->
            <!-- Section Content -->
            <div class="r1 row">
                <div class="c1 col-md-12">
                    <!-- Tab Panes -->
                    <div class="tab-content">
                        <!-- Tab Pane 2 -->
                        <div class="tab-pane fade in active" id="overview-tab-2">
                            <div class="r1 row">

                                <!-- Block 2 -->
                                <div class="c2 col-sm-6 col-md-6 animateblock ltr-2 speed-3">
                                    <div class="overview-wrapper">
                                        <div class="hidden-sm overview-icon ico-1"><User></User></div>
                                        <div class="overview-content">
                                            <h3 class="title">Вид для клиента</h3>
                                            <p class="description">
                                                У нас предусмотрена возможность организовать вход для клиентов в конкретные проекты, для показа процесса работы и статуса задач. Только то что вы хотите показывать, без вмешательства клиента в ваши внутренние процессы.</p>
                                        </div>
                                    </div>
                                    <div class="overview-wrapper">
                                        <div class="hidden-sm overview-icon ico-2"><File></File></span>
                                        </div>
                                        <div class="overview-content">
                                            <h3 class="title">Логирование </h3>
                                            <p class="description">
                                                Ведем историю всех действий всех пользователей по задачам и таскам. Всегда легко найти когда, что и кем было сделано по проекту.</p>
                                        </div>
                                    </div>
                                    <div class="overview-wrapper">
                                        <div class="hidden-sm overview-icon ico-3"><Chat></Chat></div>
                                        <div class="overview-content">
                                            <h3 class="title">Комментарии</h3>
                                            <p class="description">
                                                Что-то непонятно по задаче и нужно уточнить? Удобное обсуждение задач прямо в теле задачи. </p>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Block 2 -->
                                <!-- Block 3 -->
                                <div class="c3 col-sm-6 col-md-6 animateblock rtl-2 speed-3">
                                    <div class="overview-wrapper">
                                        <div class="hidden-sm overview-icon ico-4"><Block></Block></div>
                                        <div class="overview-content">
                                            <h3 class="title">Безопасность</h3>
                                            <p class="description">
                                                Используем SSL, SHA256 шифрование и шифрование БД, так что никто кроме вас не получит доступа к вашим данным.
                                                Возможность назначить разный набор прав разным группам и индивидуально пользователям</p>
                                        </div>
                                    </div>
                                    <div class="overview-wrapper">
                                        <div class="hidden-sm overview-icon ico-5"><Doc></Doc></div>
                                        <div class="overview-content">
                                            <h3 class="title">Файлы</h3>
                                            <p class="description">
                                                Возможность прикреплять файлы как для хранения в облаке самого трекера, так и указывать внешние ссылки. Доступ к файлам как приватный так и общий.</p>
                                        </div>
                                    </div>
                                    <div class="overview-wrapper">
                                        <div class="hidden-sm overview-icon ico-6"><Search></Search></div>
                                        <div class="overview-content">
                                            <h3 class="title">Поиск</h3>
                                            <p class="description">
                                                Умный контекстный поиск с набором настроек для получения точного результата</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Block 3 -->
                            </div>
                        </div>
                        <!-- End Tab Pane 2 -->
                    </div>
                    <!-- End Tab Panes -->
                </div>
            </div>
            <!-- End Section Content -->
        </div>
    </section>
    <!-- END OVERVIEW -->
</template>
<script>
    import User from '@/assets/svg/user.svg';
    import File from '@/assets/svg/061-file-5.svg';
    import Chat from '@/assets/svg/008-chat-3.svg';
    import Block from '@/assets/svg/094-padlock.svg';
    import Doc from '@/assets/svg/111-file.svg';
    import Search from '@/assets/svg/096-analytics.svg';

    export default {
        name: "Overview",
        components: {
            User,
            File,
            Chat,
            Block,
            Doc,
            Search
        },
        data() {
            return {

            }
        }
    }
</script>


// WEBPACK FOOTER //
// Overview.vue?1b210232